<template>
  <div>
    <div v-if="currentTaskInfo && currentTaskInfo.taskId" class="taskDetail">
      <div class="person">
        <p>{{currentTaskInfo.executeUserName || '--'}}</p>
        <p class="label">巡查人</p>
      </div>
      <div>
        <p>{{currentTaskInfo.patrolStartTime || '--'}}</p>
        <p class="label">开始时间</p>
      </div>
      <i class="iconfont icon-jiang-left"></i>
      <div>
        <p>{{currentTaskInfo.patrolEndTime || '--'}}</p>
        <p class="label">结束时间</p>
      </div>
      <div class="time">
        <p>{{currentTaskInfo.patrolDuration || '--'}}</p>
        <p class="label">巡查时长</p>
      </div>
    </div>
    <div ref="popupContent">
      <template v-if="isTaskList">
        <div v-if="!isLinePatrol && info && info.facilityId" class="patrol-point-marker-popup">
          <p class="title">{{info.facilityName || ''}}</p>
          <div class="info">
            <p class="text">类型：<span>{{info.facilityTypeName || '--'}}</span></p>
            <template v-if="info.patrolStatus !== 0">
              <p class="text">签到时间：<span>{{info.patrolTime || '--'}}</span></p>
              <div class="detail"><button class="button" style="border: none;" @click="onDetail">查看签到图片</button></div>
            </template>
          </div>
          <div class="line" v-if="info.issueList && info.issueList.length">
            <el-table class="global-table" :data="info.issueList" max-height="420">
                <el-table-column label="问题描述" prop="issueContent" min-width="100"></el-table-column>
                <el-table-column label="操作" width="60px" fixed="right">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="showProcess(row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>
        </div>
      </template>
      <template v-if="isIssueList || (isTaskList && isLinePatrol)">
        <div class="issue-marker-popup" v-if="info && info.issueId">
          <div v-if="[1, 2].includes(info.issueStatus)" class="status status1">未完成</div>
          <div v-else-if="[3, 5].includes(info.issueStatus)" class="status" :class="'status' + info.issueStatus">{{info.issueStatus === 3 ? '已完成' : '已关闭'}}</div>
          <div class="popup-content">
            <p class="header">问题详情</p>
            <div class="item w100">
              <div class="ttl">问题描述：</div>
              <div class="ctt">{{info.issueContent || ''}}</div>
            </div>
            <div class="item w100">
              <div class="ttl">现场图片/视频：</div>
              <div class="fileList">
                <div class="fileBlock" v-for="(items, index) in info.fileList" :key="index">
                  <el-image
                    v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                    :src="items.filePrefix + items.fileUrl"
                    :preview-src-list="info.fileList | imgListFormat"
                    fit="fill">
                  </el-image>
                  <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                  </video>
                </div>
              </div>
            </div>
            <div class="lineBlock">
              <div class="item">
                <div class="ttl">问题类型：</div>
                <div class="ctt">{{info.currentSafeManageName || ''}}</div>
              </div>
              <div class="item">
                <div class="ttl">问题处理人：</div>
                <div class="ctt">{{info.currentHandleUserName || ''}}</div>
              </div>
              <div class="item">
                <div class="ttl">上报人：</div>
                <div class="ctt">{{info.createUserName || ''}}</div>
              </div>
              <div class="item">
                <div class="ttl">上报时间：</div>
                <div class="ctt">{{info.ctime || ''}}</div>
              </div>
            </div>
            <template v-if="info.handleList && info.handleList.length">
              <div class="line"></div>
              <div class="flowList">
                <template v-for="(item, index) in info.handleList || []">
                  <div v-if="item.handleType >= 1 && item.handleType <= 5" class="flowItem" :key="index">
                    <div :class="'icon icon' + item.handleType">
                      <span>{{handleTypeList[Number(item.handleType) - 1]}}</span>
                    </div>
                    <div class="flowInfo">
                      <div class="flow-line">
                        <div>{{item.sendUserName || '--'}}</div>
                        <div>{{item.ctime || ''}}</div>
                      </div>
                      <div class="item-content">
                        <template v-if="item.handleType === 1">
                          <div class="item">
                            <p class="ttl">转办至：</p>
                            <p class="info">{{item.receiveUserName || ''}}</p>
                          </div>
                          <div class="item">
                            <p class="ttl">问题类型：</p>
                            <p class="info">{{item.handleManageName || ''}}</p>
                          </div>
                        </template>
                        <template v-if="item.handleType === 2">
                          <div class="item w100">
                            <p class="ttl">现场图片/视频：</p>
                            <div class="fileList">
                              <div class="fileBlock" v-for="(items, index) in item.fileList" :key="index">
                                <el-image
                                  v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                                  :src="items.filePrefix + items.fileUrl"
                                  :preview-src-list="item.fileList | imgListFormat"
                                  fit="fill">
                                </el-image>
                                <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                                </video>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="item.handleType === 3">
                          <div class="item w100">
                            <p class="ttl">整改照片/视频：</p>
                            <div class="fileList">
                              <div class="fileBlock" v-for="(items, index) in item.fileList" :key="index">
                                <el-image
                                  v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                                  :src="items.filePrefix + items.fileUrl"
                                  :preview-src-list="item.fileList | imgListFormat"
                                  fit="fill">
                                </el-image>
                                <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                                </video>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="item.handleType === 4">
                          <div class="item w100">
                            <p class="ttl">审核结果：</p>
                            <p class="info c-green" v-if="item.approvalStatus === 3">通过</p>
                            <p class="info c-red" v-else-if="item.approvalStatus === 4">驳回</p>
                          </div>
                        </template>
                        <template v-if="item.handleType === 5">
                          <div class="item w100">
                            <p class="ttl">关闭说明：</p>
                            <p class="info">{{item.handleBak || ''}}</p>
                          </div>
                        </template>
                        <div v-if="item.handleType !== 5" class="item w100">
                          <p class="ttl">备注说明：</p>
                          <p class="info">{{item.handleBak || ''}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <ImageViewer :visible.sync="isShowPic" :urlList="pointRegisterImageList"></ImageViewer>
    <el-dialog
      title="问题详情"
      :visible.sync="issueShow"
      close-on-click-modal
      width="660px">
      <div class="issue-marker-popup">
        <div class="popup-content">
          <div class="item w100">
            <div class="ttl">问题描述：</div>
            <div class="ctt">{{issueDetail.issueContent || ''}}</div>
          </div>
          <div class="item w100">
            <div class="ttl">现场图片/视频：</div>
            <div class="fileList">
              <div class="fileBlock" v-for="(items, index) in issueDetail.fileList" :key="index">
                <el-image
                  v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                  :src="items.filePrefix + items.fileUrl"
                  :preview-src-list="issueDetail.fileList | imgListFormat"
                  fit="fill">
                </el-image>
                <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                </video>
              </div>
            </div>
          </div>
          <div class="lineBlock">
            <div class="item">
              <div class="ttl">问题类型：</div>
              <div class="ctt">{{issueDetail.currentSafeManageName || ''}}</div>
            </div>
            <div class="item">
              <div class="ttl">问题处理人：</div>
              <div class="ctt">{{issueDetail.currentHandleUserName || ''}}</div>
            </div>
            <div class="item">
              <div class="ttl">上报人：</div>
              <div class="ctt">{{issueDetail.createUserName || ''}}</div>
            </div>
            <div class="item">
              <div class="ttl">上报时间：</div>
              <div class="ctt">{{issueDetail.ctime || ''}}</div>
            </div>
          </div>
          <template v-if="issueDetail.handleList && issueDetail.handleList.length">
            <div class="line"></div>
            <div class="flowList">
              <template v-for="(item, index) in issueDetail.handleList || []">
                <div v-if="item.handleType >= 1 && item.handleType <= 5" class="flowItem" :key="index">
                  <div :class="'icon icon' + item.handleType">
                    <span>{{handleTypeList[Number(item.handleType) - 1]}}</span>
                  </div>
                  <div class="flowInfo">
                    <div class="flow-line">
                      <div>{{item.sendUserName || '--'}}</div>
                      <div>{{item.ctime || ''}}</div>
                    </div>
                    <div class="item-content">
                      <template v-if="item.handleType === 1">
                        <div class="item">
                          <p class="ttl">转办至：</p>
                          <p class="info">{{item.receiveUserName || ''}}</p>
                        </div>
                        <div class="item">
                          <p class="ttl">问题类型：</p>
                          <p class="info">{{item.handleManageName || ''}}</p>
                        </div>
                      </template>
                      <template v-if="item.handleType === 2">
                        <div class="item w100">
                          <p class="ttl">现场图片/视频：</p>
                          <div class="fileList">
                            <div class="fileBlock" v-for="(items, index) in item.fileList" :key="index">
                              <el-image
                                v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                                :src="items.filePrefix + items.fileUrl"
                                :preview-src-list="item.fileList | imgListFormat"
                                fit="fill">
                              </el-image>
                              <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                              </video>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-if="item.handleType === 3">
                        <div class="item w100">
                          <p class="ttl">整改照片/视频：</p>
                          <div class="fileList">
                            <div class="fileBlock" v-for="(items, index) in item.fileList" :key="index">
                              <el-image
                                v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                                :src="items.filePrefix + items.fileUrl"
                                :preview-src-list="item.fileList | imgListFormat"
                                fit="fill">
                              </el-image>
                              <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                              </video>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-if="item.handleType === 4">
                        <div class="item w100">
                          <p class="ttl">审核结果：</p>
                          <p class="info c-green" v-if="item.approvalStatus === 3">通过</p>
                          <p class="info c-red" v-else-if="item.approvalStatus === 4">驳回</p>
                        </div>
                      </template>
                      <template v-if="item.handleType === 5">
                        <div class="item w100">
                          <p class="ttl">关闭说明：</p>
                          <p class="info">{{item.handleBak || ''}}</p>
                        </div>
                      </template>
                      <div v-if="item.handleType !== 5" class="item w100">
                        <p class="ttl">备注说明：</p>
                        <p class="info">{{item.handleBak || ''}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>

    <el-drawer :size="'500px'" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :instance-id="selectInstance"
        @handler-after="handlerAfter"></instance-preview>
    </el-drawer>
  </div>
</template>

<script>
// import vjmap from 'vjmap'
import { iconUrl } from '@/utils/config'
import { px2vw } from '@/utils/util'
import ImageViewer from '@/components/ImageViewer'
import InstancePreview from '@/views/wflow/workspace/approval/ProcessInstancePreview'
export default {
  name: 'PatrolCenter',
  components: { ImageViewer, InstancePreview },
  data () {
    return {
      processVisible: false,
      selectInstance: '',
      markerPopup: null,
      markerList: [],
      // 巡查列表 start
      currentTaskInfo: {},
      // 巡查列表 end
      info: {},
      isShowPic: false,
      pointRegisterImageList: [],
      issueShow: false,
      issueDetail: {},
      imgTypeList: ['jpeg', 'jpg', 'png'],
      videoTypeList: ['mp4', 'mov'],
      handleTypeList: ['转办', '办结', '反馈', '审核', '关闭']
    }
  },
  filters: {
    imgListFormat (list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        if (imgTypeList.find((items) => items === item.fileType)) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },
  watch: {
    '$route.path' (newPath, oldPath) {
      // 路由变化时的处理逻辑
      console.log('路由从', oldPath, '变化到', newPath, this.markerList)
      this.markerOffClick()
      this.removeMarkers()
      this.clearTaskDetail()
      this.listenChange()
    },
    projectId () {
      this.markerOffClick()
      this.removeMarkers()
      this.clearTaskDetail()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId
    },
    isIssueList () {
      return this.$route.path === '/patrol/issueList'
    },
    isTaskList () {
      return this.$route.path === '/patrol/taskList'
    },
    isLinePatrol () {
      return this.currentTaskInfo && this.currentTaskInfo.patrolMode && this.currentTaskInfo.patrolMode === 1
    }
  },
  created () {
    this.listenChange()
  },
  beforeDestroy () {
    // 巡查任务监听清除
    this.$event.$off('task-info-init')
    // 巡查问题监听清除
    this.$event.$off('marker-showPopup')
    this.markerOffClick()
    this.removeMarkers()
    this.clearTaskDetail()
  },
  methods: {
    showProcess (row) {
      this.processVisible = true
      this.selectInstance = row.processId
    },
    handlerAfter () {
      this.processVisible = false
    },
    // 页面监听
    listenChange () {
      // 巡查任务监听清除
      this.$event.$off('task-info-init')
      // 巡查问题监听清除
      this.$event.$off('marker-showPopup')
      // 巡查任务列表
      if (this.isTaskList) {
        this.$event.$on('task-info-init', (taskId) => {
          if (this._map) {
            this.showTaskDetail(taskId)
          } else {
            const interval = setInterval(() => {
              this._map = this.$parent.$children[0]._map
              if (this._map) {
                interval && clearInterval(interval)
                this.showTaskDetail(taskId)
              }
            }, 200)
          }
        })
      } else if (this.isIssueList) {
        console.log('this.$parent', this.$parent)
        this.$event.$on('list-draw-markers', (list, type) => {
          if (this._map) {
            this.addList(list, type)
          } else {
            const interval = setInterval(() => {
              this._map = this.$parent.$children[0]._map
              if (this._map) {
                interval && clearInterval(interval)
                this.addList(list, type)
              }
            }, 200)
          }
        })
        this.$event.$on('marker-showPopup', (data) => {
          this.showMarkerPopup(data, true)
        })
      }
    },
    // 获取巡查任务详情
    getTaskDetail (taskId) {
      return this.$axios.get(this.$apis.patrol.selectTaskByTaskId, {
        taskId
      })
    },
    // 获取巡查任务线路巡查路径
    getTrackList (taskId) {
      return this.$axios.get(this.$apis.patrol.selectTrackList, {
        taskId
      })
    },
    // 获取巡查任务问题列表
    getIssueList (taskId, facilityId) {
      return this.$axios.get(this.$apis.process.selectLcPatrolIssueByPages, {
        taskId,
        facilityId
      }).then((res) => {
        return res.list
      })
    },
    // 获取巡查任务问题详情
    getIssueDetail (issueId) {
      return this.$axios.get(this.$apis.patrol.selectIssueByIssueId, {
        issueId
      })
    },
    // 巡查任务列表点击单个任务展示信息
    showTaskDetail (taskId) {
      this.clearTaskDetail()
      this.getTaskDetail(taskId).then(res => {
        this.currentTaskInfo = JSON.parse(JSON.stringify(res))

        if (this.isLinePatrol) {
          const lines = this.currentTaskInfo.lineList || []
          if (lines.length) {
            const markers = [{
              ...lines[0]
            }, {
              ...lines[lines.length - 1]
            }]
            this._lineOverlays = []
            this._lineOverlays.push(this.drawPolyline(lines))
            this.drawLineMarkers(this.currentTaskInfo.taskRegisterList || [], true)
            this.drawLineMarkers(markers)
          }
          this.getTrackList(res.taskId).then(trackList => {
            const lines = trackList || []
            if (lines.length) {
              const markers = res.taskStatus !== 4
                ? [{
                    ...lines[0]
                  }]
                : [{
                    ...lines[0]
                  }, {
                    ...lines[lines.length - 1]
                  }]
              this._lineOverlays.push(this.drawPolyline(lines, '#3592FE'))
              this.drawLineMarkers(markers, false, true)
            }
            this.$parent.$children[0].setFitMarkers(px2vw(250))
          })
          // 如果有巡查问题,则在地图上打点
          if (res.issueNum) {
            this.getIssueList(res.taskId).then(issueList => {
              this.addList(issueList)
            })
          }
        } else {
          this.clearPlanPointMarkers()
          this.drawTaskDetailMarker(this.currentTaskInfo.pointList || [], true)
        }
      })
    },
    // 线路签到点、必签到点打点及线路开始结束点
    drawLineMarkers (list, isMustPoint, isDo) {
      let icon = 'sign'
      let anchor = 'center'
      let wh = '20px'
      if (isMustPoint) {
        icon = 'notpassed'
        anchor = 'bottom'
        wh = '40px'
      }
      list.forEach((item, ind) => {
        if (isDo) {
          icon = ind === 0 ? 'start' : 'end'
        }
        const lngLat = [Number(item.longitude), Number(item.latitude)]
        const el = this.getMarkerEl(require(`@/assets/img/icon/patrol/${icon}.svg`), wh, wh)
        const marker = new vjmap.Marker({
          element: el,
          anchor: anchor
        })
        marker.setLngLat(lngLat).addTo(this._map)
        if (isMustPoint) {
          const dom = window.document.createElement('div')
          dom.innerHTML = '必经点'
          dom.style.padding = '2px 8px'
          dom.style.background = 'var(--map-popup-bg)'
          dom.style.color = 'var(--map-popup-font-color)'
          dom.style.borderRadius = '10px'
          const popup = new vjmap.Popup({ offset: [0, -40], closeButton: false, closeOnClick: false })
            .setDOMContent(dom)
          marker.setPopup(popup)
          if (!popup.isOpen()) marker.togglePopup()
        }
        if (isDo) {
          this._doLineMarkers.push(marker)
        } else {
          this._lineOverlays.push(marker)
        }
      })
    },
    // 巡查线路添加
    drawPolyline (list, color) {
      if (list && list.length) {
        const lngLats = list.map(item => {
          return [item.longitude, item.latitude]
        })
        const polyline = new vjmap.Polyline({
          data: lngLats,
          lineColor: color || '#FF9B00',
          lineWidth: 4
        })
        polyline.addTo(this._map)
        return polyline
      } else {
        return null
      }
    },
    getIcon (icon) {
      let iconPath = ''
      switch (icon) {
        case '1':
          iconPath = require('../../assets/img/icon/issue/unfinished.svg')
          break
        case '2':
          iconPath = require('../../assets/img/icon/issue/finished.svg')
          break
        case '3':
        case '4':
        case '5':
          iconPath = require('../../assets/img/icon/issue/close.svg')
          break
      }
      return iconPath
    },
    addList (list, type) {
      if (!(type && type === 'add')) {
        this.removeMarkers()
      }
      ;(list || []).forEach(item => {
        if (item.longitude && item.latitude) {
          const el = this.getMarkerEl(this.getIcon(item.issueStatus || item.icon))
          const marker = new vjmap.Marker({
            element: el,
            anchor: 'bottom'
          })
          marker.setLngLat([item.longitude, item.latitude]).addTo(this._map)
          marker.extData = { ...item }
          marker.on('click', this.markerClick)
          this.markerList.push(marker)
        }
      })
      this.$parent.$children[0].setFitMarkers()
    },
    // 点位巡查
    // 获取点位信息
    getMarkerEl (iconPath, w, h) {
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = `url(${iconPath})`
      el.style.width = w || '40px'
      el.style.height = h || '40px'
      el.style.backgroundSize = '100%'
      return el
    },
    // 任务详情点位详情点位打点
    drawTaskDetailMarker (list) {
      list.forEach(fItem => {
        if (fItem.longitude && fItem.latitude) {
          const lngLat = [Number(fItem.longitude), Number(fItem.latitude)]
          const el = this.getMarkerEl(iconUrl + (fItem.icon || fItem.facilityIcon) + '_' + fItem.patrolStatus + '.png')
          const marker = new vjmap.Marker({
            element: el,
            anchor: 'center'
          })
          marker.extData = { ...fItem }
          marker.setLngLat(lngLat).addTo(this._map)
          marker.on('click', this.pointMarkerClick)
          this.markerList.push(marker)
        }
      })
      this.$parent.$children[0].setFitMarkers()
    },
    pointMarkerClick (e) {
      this.showMarkerPopup(e.target.extData)
    },
    clearPlanPointMarkers () {
      if (this._planPointMarkers && this._planPointMarkers.length) {
        this._planPointMarkers.forEach(item => {
          item.remove()
        })
      }
    },
    // 清除中间地图上单个巡查任务相关信息
    clearTaskDetail () {
      this.currentTaskInfo = null
      console.log('clearLineOverlays:', this._lineOverlays)
      if (this._lineOverlays) {
        this._lineOverlays.forEach(item => {
          item && item.remove()
        })
      }
      if (this._doLineMarkers) {
        this._doLineMarkers.forEach(item => {
          item.remove()
        })
      }
      this._doLineMarkers = []
      this.removeMarkers()
    },
    // 删除地图列表打点信息
    removeMarkers () {
      console.log('removeMarkers:', this.markerList)
      this.markerList.forEach(marker => {
        marker.off('click', this.markerClick)
        marker.remove()
      })
      if (this.markerPopup) {
        this.markerPopup.setHTML('')
      }
      this.markerList = []
      if (this._map) {
        const markers = this._map.getMarkers()
        if (markers && markers.length) {
          markers.forEach(info => {
            info.remove()
          })
        }
      }
    },
    markerClick (e) {
      this.showMarkerPopup(e.target.extData)
    },
    markerOffClick () {
      this.markerList.forEach(marker => {
        marker.off('click', this.markerClick)
      })
    },
    showMarkerPopup (data, isSetCenter) {
      if (this.markerPopup) {
        this.markerPopup.setHTML('')
      } else {
        this.markerPopup = new vjmap.Popup({ closeButton: false })
      }
      const idText = this.isIssueList || (this.isTaskList && this.isLinePatrol) ? 'issueId' : 'facilityId'
      console.log('idText', idText, data)
      const ind = this.markerList.findIndex(item => item.extData && item.extData[idText] === data[idText])
      console.log(data, ind)
      if (ind >= 0) {
        const marker = this.markerList[ind]
        // 如果是工单，或者线路巡查问题点击，则调取详情
        if (this.isIssueList || (this.isTaskList && this.isLinePatrol)) {
          console.log('到了这里了1')
          this.showProcess(data)
          // this.getIssueDetail(data.issueId).then(res => {
          //   this.info = JSON.parse(JSON.stringify(res || {}))
          //   this.$nextTick(() => {
          //     this.markerPopup.setDOMContent(this.$refs.popupContent)
          //     marker.setPopup(this.markerPopup)
          //     if (!this.markerPopup.isOpen()) {
          //       marker.togglePopup()
          //     }
          //     if (isSetCenter) {
          //       this._map.setCenter(marker.getLngLat())
          //     }
          //   })
          // })
        } else if (this.isTaskList && !this.isLinePatrol) {
          console.log('到了这里了2')
          this.info = { ...data }
          if (this.info.standardIssueCount > 0) {
            this.getIssueList(data.taskId, data.facilityId).then(res => {
              this.$set(this.info, 'issueList', res || [])
              this.$nextTick(() => {
                console.log('this.info:', this.info)
                this.markerPopup.setDOMContent(this.$refs.popupContent)
                marker.setPopup(this.markerPopup)
                if (!this.markerPopup.isOpen()) {
                  marker.togglePopup()
                }
              })
            })
          } else {
            console.log('到了这里了3')
            this.info.issueList = []
            this.$nextTick(() => {
              this.markerPopup.setDOMContent(this.$refs.popupContent)
              marker.setPopup(this.markerPopup)
              if (!this.markerPopup.isOpen()) {
                marker.togglePopup()
              }
            })
          }
        } else {
          console.log('到了这里了4')
          this.info = { ...data }
          this.$nextTick(() => {
            this.markerPopup.setDOMContent(this.$refs.popupContent)
            marker.setPopup(this.markerPopup)
            if (!this.markerPopup.isOpen()) {
              marker.togglePopup()
            }
          })
        }
      }
    },
    // 点位巡查查看巡查图片
    onDetail () {
      this.pointRegisterImage = this.info.pointRegisterImage
      this.pointRegisterImageList = this.info.pointRegisterImage.map(item => {
        return {
          name: item.fileName,
          url: item.filePrefix + item.fileUrl
        }
      })
      this.isShowPic = true
    },
    // 点位巡查查看具体巡查问题
    onShowIssueDetail (processId) {
      // this.issueDetail = {}
      // this.getIssueDetail(issueId).then(res => {
      //   this.issueDetail = { ...res }
      // })
      // this.issueShow = true
    }
  }
}
</script>

<style scoped lang='scss'>
  .taskDetail {
    position: fixed;
    left: calc(50% - 310px);
    bottom: 50px;
    width: 620px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #F6F6F6;
    box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
    border-radius: 0px 4px 4px 4px;
    z-index: 300;
    &>div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      &.person {
        width: 122px;
        background: #ffffff;
      }
      &.time {
        position: relative;
        width: 110px;
        &::before {
          content: "";
          width: 1px;
          height: 24px;
          position: absolute;
          left: 0;
          top: calc( 50% - 12px);
          background: #c3c3c3;
        }
      }
    }
    i {
      font-size: 24px;
      color: #000000;
    }
    p {
      width: 100%;
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      line-height: 16px;
      text-align: center;
      padding: 0 20px;
      &.label {
        color: #999999;
      }
    }
  }
  .issue-marker-popup {
    margin: -20px 20px 40px;
    .status {
      display: inline-block;
      position: relative;
      width: auto;
      height: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 12px;
      color: #FEFEFE;
      line-height: 15px;
      background: #F5A623;
      padding: 2px 8px;
      &::before {
        content: "";
        position: absolute;
        right: -5px;
        bottom: 0;
        width: 9px;
        height: 100%;
        background: #F5A623;
        transform: skewX(25deg);
      }
      &.status3, &.status3::before  {
        background: #39C44A;
      }
      &.status5, &.status5::before  {
        background: #ABABAB;
      }
    }
    .popup-content {
      width: 620px;
      height: auto;
      padding: 14px 19px;
      color: var(--map-popup-font-color);
      background: var(--map-popup-bg);
      box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
      .w100 {
        width: 100% !important;
      }
      .header {
        font-size: 16px;
        line-height: 18px;
        margin-bottom: 20px;
      }
      .lineBlock {
        display: flex;
        flex-wrap: wrap;
      }
      .item {
        display: flex;
        width: 50%;
        line-height: 14px;
        margin-bottom: 20px;
        .ttl {
          flex-shrink: 0;
        }
      }

      .fileList {
        display: flex;
        flex-wrap: wrap;
        width: calc(100% + 10px);
      }
      .fileBlock {
        width: 70px;
        height: 70px;
        margin: 0 10px 10px 0;
        .el-image {
          width: 100%;
          height: 100%;
        }
        video {
          width: 100%;
          height: 100%;
        }
      }
      .line {
        border-top: 1px solid var(--map-popup-border);
        margin-bottom: 20px;
      }
      .flowList {
        max-height: 300px;
        overflow-y: auto;
        .flowItem {
          position: relative;
          display: flex;
          padding-bottom: 10px;
          z-index: 2;
          .icon {
            width: 40px;
            height: 20px;
            font-size: 12px;
            color: #FFF;
            text-align: center;
            line-height: 20px;
            background: #02B7AE;
            border-radius: 10px;
            &::before {
              content: '';
              position: absolute;
              top: 20px;
              left: 19px;
              width: 2px;
              height: calc(100% - 20px);
              background: #F1F1F1;
              z-index: -1;
            }
            &.icon2{
              background: #39C44A;
            }
            &.icon3 {
              background: #F5A523;
            }
            &.icon4 {
              background: #D1021C;
            }
            &.icon5 {
              background: #8C8C8C;
            }
          }
          &:last-child {
            .icon::before {
              height: calc(100% - 30px);
            }
          }
          .flowInfo {
            width: 100%;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            line-height: 14px;
            padding: 10px;
            margin-left: 10px;
            border-radius: 4px;
            background: var(--map-popup-bg2);
            .flow-line {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
            }
            .item-content {
              .item {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
  .patrol-point-marker-popup {
    width: 300px;
    height: auto;
    padding: 14px 19px;
    color: var(--map-popup-font-color);
    background: var(--map-popup-bg);
    box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
    margin: 20px;
    .title {
      width: 100%;
      height: auto;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      margin-bottom: 15px;
    }
    .info{
      padding-bottom: 20px;
      .text{
        font-size: 14px;
        line-height: 20px;
        &:not(:last-child) {
          padding-bottom: 10px;
        }
        span {
          opacity: 0.8;
        }
      }
      .detail {
        width: 100%;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        .button {
          user-select: none;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 116px;
          height: 32px;
          background: #5750EB;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 22px;
        }
      }
    }
    .line {
      border-top: 1px solid #F1F1F1;
      padding-top: 20px;
    }
  }
  .el-dialog {
    .issue-marker-popup {
      margin: 0;
      .popup-content {
        width: 100%;
        padding: 0px;
        box-shadow: none;
      }
    }
  }
</style>
